export const LANGUAGE_OPTIONS = [
  { value: 'english', label: 'English' },
  { value: 'french', label: 'French' },
  { value: 'spanish', label: 'Spanish' },
  { value: 'german', label: 'German' },
  { value: 'italian', label: 'Italian' },
  { value: 'portuguese', label: 'Portuguese' },
  { value: 'dutch', label: 'Dutch' },
  { value: 'chinese', label: 'Chinese' },
  { value: 'japanese', label: 'Japanese' },
  { value: 'korean', label: 'Korean' },
  { value: 'hindi', label: 'Hindi' },
  { value: 'arabic', label: 'Arabic' },
  { value: 'russian', label: 'Russian' },
  { value: 'polish', label: 'Polish' },
  { value: 'swedish', label: 'Swedish' },
  { value: 'turkish', label: 'Turkish' },
  { value: 'vietnamese', label: 'Vietnamese' },
  { value: 'greek', label: 'Greek' },
  { value: 'czech', label: 'Czech' },
  { value: 'danish', label: 'Danish' },
  { value: 'finnish', label: 'Finnish' },
  { value: 'hungarian', label: 'Hungarian' },
  { value: 'norwegian', label: 'Norwegian' },
  { value: 'romanian', label: 'Romanian' },
  { value: 'slovak', label: 'Slovak' },
  { value: 'croatian', label: 'Croatian' },
  { value: 'bulgarian', label: 'Bulgarian' },
  { value: 'filipino', label: 'Filipino' },
  { value: 'indonesian', label: 'Indonesian' },
  { value: 'malay', label: 'Malay' },
  { value: 'tamil', label: 'Tamil' },
  { value: 'ukrainian', label: 'Ukrainian' },
  { value: 'hebrew', label: 'Hebrew' },
  { value: 'thai', label: 'Thai' }
]

export const LANGUAGE_LABEL_MAP = Object.fromEntries(
  LANGUAGE_OPTIONS.map((item) => [item.value, item.label])
)

